module.exports = __webpack_public_path__ + "img/tree-left.25858437.svg";